var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FF8F6B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9303 25C34.9621 24.9291 34.977 24.8519 34.9739 24.7743H35C34.8882 22.1059 32.6849 20 30.0049 20C27.325 20 25.1217 22.1059 25.0099 24.7743C24.9967 24.849 24.9967 24.9253 25.0099 25H24.9317C23.6502 25 22.2803 25.846 21.8826 28.1201L21.1049 34.3147C20.4686 38.8629 22.8106 40 25.8685 40H34.1585C37.2075 40 39.4789 38.3535 38.9133 34.3147L38.1444 28.1201C37.676 25.9096 36.3503 25 35.0865 25H34.9303ZM33.4932 25C33.4654 24.9279 33.4506 24.8515 33.4497 24.7743C33.4497 22.8568 31.8899 21.3024 29.9657 21.3024C28.0416 21.3024 26.4818 22.8568 26.4818 24.7743C26.495 24.849 26.495 24.9253 26.4818 25H33.4932ZM27.097 30.1486C26.6089 30.1486 26.2132 29.7413 26.2132 29.2389C26.2132 28.7366 26.6089 28.3293 27.097 28.3293C27.5851 28.3293 27.9808 28.7366 27.9808 29.2389C27.9808 29.7413 27.5851 30.1486 27.097 30.1486ZM32.002 29.2389C32.002 29.7413 32.3977 30.1486 32.8858 30.1486C33.3739 30.1486 33.7696 29.7413 33.7696 29.2389C33.7696 28.7366 33.3739 28.3293 32.8858 28.3293C32.3977 28.3293 32.002 28.7366 32.002 29.2389Z",
    fill: "#FF8F6B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingIcon);
export default __webpack_public_path__ + "static/media/shopping_icon.7f80a8cef2b757d1d2998dfb97ce5137.svg";
export { ForwardRef as ReactComponent };